<ab-account-manager-information> </ab-account-manager-information>
<ng-container *ngIf="isLoading">
  <div class="ao-block">
    <header class="ao-header">
      <div class="row">
        <div class="col-sm-7"></div>

        <div class="col-sm-5 actions-group">
          <button class="btn float-right btn-white btn-icon">
            <i class="icon icon-settings"></i>
            <!--
            To be implemented when account prefs is implemented
            [ngClass]="{'icon-rotate' : isLoading.savePrefs}"-->
          </button>
        </div>
      </div>
    </header>
    <div class="table-responsive">
      <table class="table table-striped ao-table">
        <colgroup class="row">
          <col class="col-md-2 col-sm-2" />
          <col class="col-md-4 col-sm-4" />
          <col class="col-md-1" />
          <col class="col-md-2" />
          <col class="col-md-2" />
          <col class="col-md-1" />
        </colgroup>
        <thead>
          <tr>
            <th
              [ngClass]="item.fields.css.value"
              *ngFor="let item of rendering.fields.items"
            >
              <span *scText="item.fields.label"></span>
              <i
                *ngIf="item.fields.hint.value"
                class="icon-info-circle tooltip-icon"
                matTooltipClass="info-tooltip"
                [matTooltip]="item.fields.hint.value"
              ></i>
            </th>
            <th *ngIf="rendering.fields.actions.length"></th>
          </tr>
        </thead>
      </table>
      <div class="loader-bar"></div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="!isLoading">
  <section class="ao-block">
    <header class="ao-header">
      <div class="row">
        <div class="col-sm-7">
          <h2 class="ao-header-title text-overflow">
            <i class="icon-single" [hidden]="!portfolio.isSingle"></i>
            <i class="icon-joint" [hidden]="!portfolio.isJoint"></i>
            <i class="icon-corporate" [hidden]="!portfolio.isCorporate"></i>
            <span class="overview-title">{{ portfolio.name }}</span>
          </h2>
        </div>

        <div
          class="col-sm-5 actions-group d-flex justify-content-end align-items-center"
        >
          <a
            *ngIf="
              isRetail &&
              rendering.fields.newAccountNewLink &&
              rendering.fields.newAccountNewLink.value.href
            "
            class="btn btn-white action-link"
            [routerLink]="rendering.fields.newAccountNewLink.value.href"
            >{{ rendering.fields.newAccountNewLink.value.text }}</a
          >
          <button
            class="btn float-right btn-white btn-icon"
            (click)="openDialog(portfolio)"
            matTooltipClass="info-tooltip"
            [matTooltip]="rendering.fields.accountSettingsToolTip.value"
          >
            <i class="icon icon-settings"></i>
            <!--
            To be implemented when account prefs is implemented
            [ngClass]="{'icon-rotate' : isLoading.savePrefs}"-->
          </button>
        </div>
      </div>
    </header>
    <div class="table-responsive">
      <table class="table table-striped ao-table">
        <colgroup class="row">
          <col class="col-md-2 col-sm-2" />
          <col class="col-md-4 col-sm-4" />
          <col class="col-md-1" />
          <col class="col-md-2" />
          <col class="col-md-2" />
          <col class="col-md-1" />
        </colgroup>
        <thead>
          <tr>
            <th
              [ngClass]="item.fields.css.value"
              *ngFor="let item of rendering.fields.items"
            >
              <span *scText="item.fields.label"></span>
              <i
                *ngIf="item.fields.hint.value"
                class="icon-info-circle tooltip-icon"
                matTooltipClass="info-tooltip"
                [matTooltip]="item.fields.hint.value"
              ></i>
            </th>
            <th *ngIf="rendering.fields.actions.length"></th>
          </tr>
        </thead>
        <tbody>
          <!-- ngRepeat: product in portfolio.Products -->
          <!-- ngIf: product.Visible -->
          <ng-container *ngFor="let product of portfolio.products">
            <tr *ngIf="product.visible">
              <td>
                <a
                  *ngIf="product.isLinkActive"
                  routerLink="/transactions/overview"
                  [queryParams]="{ id: product.accountId }"
                  >{{ product.accountNumber }}</a
                >
                <span *ngIf="!product.isLinkActive">{{
                  product.accountNumber
                }}</span>
              </td>
              <td>
                {{ product.accountName }}
                <small *ngIf="product.status !== 'open'" class="text-muted">
                  <em>({{ product.status }})</em>
                </small>
              </td>
              <td class="text-center">
                {{ product.bookBalance.currencyCode }}
              </td>
              <td class="text-right">
                {{ product.bookBalance.amount | currency: '':'' }}
              </td>
              <td class="text-right">
                {{ product.availableBalance.amount | currency: '':'' }}
              </td>
              <td class="text-right">
                <div>
                  <button
                    type="button"
                    [matMenuTriggerFor]="appMenu"
                    [disabled]="product.accountActions == null"
                    class="btn btn-icon-square btn-actions"
                    [ngClass]="
                      product.accountActions == null ? 'btn-disabled' : ''
                    "
                  >
                    <i
                      [ngClass]="
                        product.status === 'blocked'
                          ? 'icon-locker'
                          : product.status === 'closed' ||
                            product.status === 'pending_closure'
                          ? 'icon-block'
                          : 'icon-equal-sign'
                      "
                    ></i>
                  </button>
                  <mat-menu
                    class="actions-list"
                    #appMenu="matMenu"
                    yPosition="above"
                    xPosition="before"
                    hasBackdrop="false"
                  >
                    <ul class="list-unstyled">
                      <li
                        class="actions-list-item"
                        *ngFor="let action of product.accountActions"
                      >
                        <a (click)="openUrl(action.url)">{{ action.name }}</a>
                      </li>
                    </ul>
                  </mat-menu>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </section>
  <form
    method="post"
    name="mashupform"
    [action]="mashupUrl"
    target="_blank"
    style="display:none"
  >
    <input id="tokenInput" type="hidden" name="token" />
  </form>
</ng-container>
